// Amounts are shown in their own currency, never converted and never under a bare "$"
// (Scott, 2026-10-03: salary figures are broken down by currency).

// "USD 120K". Without a currency, the number alone.
export function fmtAmount(n, currency) {
  if (n == null) return '—'
  const v = n >= 1000000 ? `${(n / 1000000).toFixed(1)}M` : n >= 1000 ? `${Math.round(n / 1000)}K` : `${Math.round(n)}`
  return currency ? `${currency} ${v}` : v
}

// An org unit's median salary (routers/profile.org_unit_salary_summary): one figure when the
// unit is paid in one currency; each currency's median, largest first, when it is paid in
// several -- never one blended number.
export function unitMedianSalaryText(unit) {
  if (!unit) return '—'
  if (unit.median_salary != null) return fmtAmount(unit.median_salary, unit.median_salary_currency)
  const per = unit.median_salary_by_currency || []
  if (!per.length) return '—'
  return per.map(c => fmtAmount(c.median, c.currency)).join(' · ')
}
